export default __webpack_public_path__ + "static/tuGraz-bde2a739f73271db4cff54fa157e4ec0.svg";